import type { EventYear } from './types';
import { event2025 } from './years/2025';
import { event2026 } from './years/2026';

// Registry of all AGM events, keyed by year. To add a year: create
// data/years/<year>/* and register the event here, then set it `isCurrent` (and
// clear the previous current event's flag).
export const events: Record<number, EventYear> = {
  2025: event2025,
  2026: event2026,
};

/**
 * The default landing year — the event marked `isCurrent`. Derived from the data
 * (not `new Date()`) so the default is explicit and predictable; exactly one event
 * must be current (enforced by tests).
 */
export const CURRENT_YEAR: number =
  Object.values(events).find((event) => event.meta.isCurrent)?.meta.year ??
  Math.max(...Object.keys(events).map(Number));

/** Look up an event by year, or undefined if no such year exists. */
export function getEvent(year: number): EventYear | undefined {
  return events[year];
}

/** Whether the given year has a registered event. */
export function isValidYear(year: number): boolean {
  return year in events;
}

/** All event years, newest first. */
export function getAllYears(): number[] {
  return Object.keys(events)
    .map(Number)
    .sort((a, b) => b - a);
}
